import React, { useEffect, useRef, useState } from "react";
import emailjs from "emailjs-com";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";

const ContactSection = ({ scrollToConsult }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [buttonText, setButtonText] = useState("Send Message");
  const [alertType, setAlertType] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    setMobileNumber(value);
    setError("");
  };

  const validateMobileNumber = () => {
    const ukMobileRegex = /^0\d{10}$/;

    if (!ukMobileRegex.test(mobileNumber)) {
      setError("Please enter a valid 11 digit UK mobile number.");
    }
  };

  const submitBtn = document.getElementById("submit-btn");

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonText("Sending...");

    emailjs
      .sendForm(
        "service_2cnqd96",
        "template_bcda4fr",
        e.target,
        "nQBJzdhm_0rQ4QbLv"
      )
      .then(
        (result) => {
          setAlertMessage(
            "Thank you for contacting, one of our team will be in touch soon!"
          );
          setAlertType("success");
          // setShowAlert(true);
          e.target.reset();
          setButtonText("Send Message");
          setShowModal(true);
        },
        (error) => {
          setAlertMessage("Failed to send message. Please try again.");
          setAlertType("danger");
          setShowAlert(true);
          alert("Error during form submission:", error);
          setButtonText("Send Message");
        }
      );
  };

  const handleScroll = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleScroll, {
      threshold: 0.1, // Adjust threshold as needed
    });
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className="row" ref={ref} id="contact-us">
      <div className="col-lg-6">
        <iframe
          title="map"
          // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2349.365759136127!2d-1.8295329230041755!3d53.92524553125128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bfae3ed12ed73%3A0xb201e565462d5dc8!2sRegent%20Orthodontics!5e0!3m2!1sen!2s!4v1729688462823!5m2!1sen!2s"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2349.3634627964525!2d-1.829512522984527!3d53.925286331248124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bfb0d2dc24b8d%3A0x28e350785104eddc!2sRegent%20Dental!5e0!3m2!1sen!2s!4v1738618864261!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="col-lg-6 bg-theme">
        <div className="container py-5 px-4">
          <h2
            className={`fs-40 text-white animate__animated ${
              isVisible ? "animate__fadeIn" : "animate__fadeOut"
            }`}
          >
            Ready To Get Started?
          </h2>
          <p
            className={`fs-16 fw-500 text-white animate__animated ${
              isVisible ? "animate__fadeIn" : "animate__fadeOut"
            }`}
          >
            Discover a confident new smile and save over £1,000 with our offer.
          </p>

          <ul
            className={`list-unstyled text-white ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            <li>
              {" "}
              <p className="fs-17">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden fw-700">10% </span> off your
                treatment
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden fw-700">FREE</span> CBCT Scan
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden fw-700">£100</span> Consultation Fee
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden fw-700">FREE</span> 1st Year Annual
                Review (worth £150)
              </p>{" "}
            </li>
          </ul>
          <p
            className={`fs-15 fw-400 text-white ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            <i>** Where treatment has been carried out</i>
          </p>

          <div className="row mt-5 g-0">
            <div className="col-lg-6 mb-3">
              <button
                className={`btn btn-golden animate__animated ${
                  isVisible ? "animate__slideInUp" : "animate__fadeOut"
                }`}
                onClick={scrollToConsult}
              >
                <a href="#consult" className="text-white">
                  {" "}
                  BOOK A FREE CONSULTATION
                </a>
              </button>
            </div>
            <div className="col-lg-6 mb-3">
              {/* <button className={`btn btn-outline-light px-3 rounded-pill btn-lg animate__animated ${isVisible ? 'animate__slideInUp' : 'animate__fadeOut'}`}><i class="fa fa-phone me-3"></i>07551936840</button> */}
            </div>
          </div>
        </div>
      </div>
      {/* Success Modal */}
      {showModal && (
        <div
          className="modal d-block border-0"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content bg-success text-white">
              <div className="modal-header bg-theme d-flex justify-content-end border-0">
                <a type="button" onClick={() => setShowModal(false)}>
                  <i class="fa fa-times text-white" aria-hidden="true"></i>
                </a>
              </div>
              <div className="modal-body bg-theme p-4 text-center">
                <p className="fs-20">
                  <span className="text-golden">Thank you</span> for getting in
                  touch, one of the team will be in touch soon!
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactSection;
